import React, { useState, useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts'; 
import axios from 'axios';
import { useUser } from '../../providers/UserContext';
import { Modal, Tooltip } from 'antd';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import PrincipalStats from './PrincipalStats';
import NoReviewsCard from '../NoReviewsCard/NoReviewsCard';
import PremiumRequiredCard from '../PremiumRequiredCard/PremiumRequiredCard';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import './MyBusiness.css';

const MyBusiness = ({ selected }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [selectedRating, setSelectedRating] = useState(null);
  const [selectedHour, setSelectedHour] = useState(null);
  const [sentimentCategory, setsentimentCategory] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [loading, setLoading] = useState(false); // Estado para completar la carga
  const [usuario, setUsuario] = useState(null);
  const [isExpired, setIsExpired] = useState(true);
  const [showLimitModal, setShowLimitModal] = useState(false); // Estado para mostrar el modal
  const [error, setError] = useState(false);
  const scrollContainerRef = useRef(null);

  const isMobile = window.innerWidth <= 768;

  const apiUrl = process.env.REACT_APP_API_URL;

  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const { user } = useUser();
  const [businessData, setBusinessData] = useState(user?.business_data || null);

  const fetchUser = async () => {
    if (user && user.businessId) {
      try {
        // const collection = 'user';
        // var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
        // const response = await axios.get(`${apiUrl}/collections/${collection}/${userUID}`);
        // setUsuario(response.data);

        // const checkSubscriptionStatus = (usuario) => {
        //   const parseDate = (dateString) => {
        //     const [day, month, year] = dateString.split('/').map(Number);
        //     return new Date(year, month - 1, day); // Los meses en JavaScript son indexados desde 0
        //   };
      
        //   if (usuario) {
        //     if (!usuario.is_premium) {
        //       const registrationDate = parseDate(usuario.date);
        //       const expirationDate = new Date(registrationDate);
        //       expirationDate.setDate(expirationDate.getDate() + 7);
        //       const currentDate = new Date();
        //       setIsExpired(currentDate > expirationDate);
        //     }
        //   }
        // };
      
        //checkSubscriptionStatus(user);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setError(true);
      }
    }
    // else if (user){
    //   if(!user.businessId){
    //     window.location.reload()
    //   }
    // }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (user && user.business_data) {
        try {
          // const collection = 'todo_restaurantes_españa';
          // const response = await axios.get(`${apiUrl}/collections/${collection}/${user.businessId}`);
          setBusinessData(user.business_data);
        } catch (error) {
          console.error('Error fetching data:', error);
          setError(true);
        }
      } else if (user && !user.business_data){
        window.location.reload()
      }
    };

    fetchData();
    fetchUser();
  }, [user, selected]);

  const handleCloseLimitModal = async ()=> {
    setShowLimitModal(false);
    navigate("/plans");
  };
/*
  const showToast = () => {
    toast.info(t('myBusinessToast'), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
*/
useEffect(()=>{
  
  const hasOneMonthPassed = (storedDateString) => {

    const [day, month, year] = storedDateString.split("/");
    const storedDate = new Date(`${year}-${month}-${day}`);
  
    const currentDate = new Date();
    const yearDifference = currentDate.getFullYear() - storedDate.getFullYear();
    const monthDifference = currentDate.getMonth() - storedDate.getMonth();
  
    return (yearDifference * 12 + monthDifference) >= 1;
  };

  
const updateUserPlan = async () => {
  if(user){
    user.is_premium = false;
    const dataToSend = {
      email: user.email,
      id_negocio: user.id_negocio,
      is_premium: false,
    };

    console.log('Data being sent to API:', dataToSend);

    try {
      const response = await axios.post(`${apiUrl}/collections/update-user-date`, dataToSend);
      console.log('API response:', response.data);
    } catch (error) {
      console.error('Error in API call:', error.response ? error.response.data : error.message);
      return;
    }
  }else{
    return;
  }
};

  if(user && user.date && user.is_premium){
    if(hasOneMonthPassed(user.date)){
      console.log('Ha pasado más de un mes.');
      setShowLimitModal(true);
      updateUserPlan();
      fetchUser();
    }else{
      console.log('No ha pasado un mes.')
    }
  }
}, [user])

  useEffect(() => {
    if (modalVisible && scrollContainerRef.current) {
      setTimeout(() => {
        scrollContainerRef.current.scrollTop = 0;
      }, 100); // Usamos un pequeño retraso para asegurarnos de que el contenido está renderizado
    }
  }, [modalVisible]);

  const getModalTitle = () => {
    if (selectedDate) {
      return `${t('reviews')}: ${formatDate(selectedDate)}`;
    } else if (selectedRating) {
      return t('modals.star-review', {selectedRating: selectedRating});
    } else if (selectedHour !== null) {
      return t('modals.hour-review', {selectedHour: selectedHour});
    } else if (sentimentCategory) {
      switch (sentimentCategory) {
        case 'positivas':
            return t('modals.positive-review');
        case 'negativas':
            return t('modals.negative-reviews');
        case 'neutrales':
            return t('modals.neutral-review');
        default:
            return t('modals.reviews');
      }
    } else if (selectedDay) {
      return t('modals.day-review', {selectedDay: t(selectedDay.toLowerCase())});
    }
    return t('modals.detail-review');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  // Datos de los gráficos
  const ratingsDistribution = [0, 0, 0, 0, 0];
  const reviewsByRating = [[], [], [], [], []];
  const reviewsByDate = {};
  const reviewsByHour = Array(24).fill(0);
  const reviewsByHourData = Array(24).fill().map(() => []);
  const reviewsBySentiment = {
    positivas: [],
    neutrales: [],
    negativas: []
  };
  const sentimentData = {
    positivas: 0,
    neutrales: 0,
    negativas: 0,
  };

  if (businessData && Array.isArray(businessData.allReviews) && businessData.allReviews.length > 0) {
    businessData.allReviews.forEach(review => {
      const rating = review.rating;
      if (rating >= 1 && rating <= 5) {
        ratingsDistribution[rating - 1]++;
        reviewsByRating[rating - 1].push(review);
      }

      const date = new Date(review.date);
      const yearMonth = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      if (!reviewsByDate[yearMonth]) {
        reviewsByDate[yearMonth] = [];
      }
      reviewsByDate[yearMonth].push(review);

      const hour = date.getHours();
      reviewsByHour[hour]++;
      reviewsByHourData[hour].push(review);

      if (review.rating >= 4) {
        sentimentData.positivas++;
        reviewsBySentiment.positivas.push(review);
      } else if (review.rating >= 2) {
        sentimentData.neutrales++;
        reviewsBySentiment.neutrales.push(review);
      } else {
        sentimentData.negativas++;
        reviewsBySentiment.negativas.push(review);
      }
    });
  }

  const sortedLabels = Object.keys(reviewsByDate).sort();
  const data = sortedLabels.map(label => reviewsByDate[label].length);

  // RESEÑAS EN EL TIEMPO
const chart_1 = {
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    left: 0,
    right: 0,
    top: 6,
    bottom: 0,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: sortedLabels,
    axisLine: { show: true },
    axisLabel: { show: true, rotate: isMobile ? 50 : 0 },
    axisTick: { show: false },
    splitLine: { show: false }
  },
  yAxis: {
    type: 'value',
    axisLine: { show: true },
    axisLabel: { show: true },
    axisTick: { show: false },
    splitLine: { show: false }
  },
  series: [{
    data: data,
    type: 'line',
    smooth: true,
    symbol: 'circle',
    lineStyle: {
      color: '#273C5A'  // Nuevo color de línea
    },
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, 
          color: '#EFC94C'  // Nuevo color con 50% de opacidad
        }, {
          offset: 1, 
          color: 'rgba(239, 201, 76,0.05)'  // Nuevo color con 5% de opacidad
        }]
      }
    }
  }]
};

  // RESEÑAS SEGUN LA HORA
  const chart_2 = {
    tooltip: {
      trigger: 'axis',
    },
    grid: {
      left: 0,
      right: 0,
      top: 6,
      bottom: 0,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: Array.from({ length: 24 }, (_, i) => `${i}:00`),
      axisLine: { show: true },
      axisLabel: { show: true, rotate: isMobile ? 50 : 0 },
      axisTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      type: 'value',
      axisLine: { show: true },
      axisLabel: { show: true },
      axisTick: { show: false },
      splitLine: { show: false }
    },
    series: [{
      data: reviewsByHour,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      lineStyle: {
        color: '#273C5A'
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: 'rgba(239, 201, 76,0.5)'
          }, {
            offset: 1, color: 'rgba(239, 201, 76,0.05)'
          }]
        }
      }
    }]
  };

  // RESEÑAS SEGÚN DÍA DE LA SEMANA
  const reviewsByDayOfWeek = [[], [], [], [], [], [], []];
  const dayOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
  const calculateAverageRatingsByDayOfWeek = () => {
    const averageRatings = [0, 0, 0, 0, 0, 0, 0];
    const reviewsCountByDayOfWeek = [0, 0, 0, 0, 0, 0, 0];
  
    if(businessData && Array.isArray(businessData.allReviews) && businessData.allReviews.length > 0){      
      businessData.allReviews.forEach(review => {
        const dayOfWeek = new Date(review.date).getDay();
        averageRatings[dayOfWeek] += review.rating;
        reviewsCountByDayOfWeek[dayOfWeek]++;
        reviewsByDayOfWeek[dayOfWeek].push(review);
      });
    
      for (let i = 0; i < 7; i++) {
        if (reviewsCountByDayOfWeek[i] > 0) {
          averageRatings[i] = (averageRatings[i] / reviewsCountByDayOfWeek[i]).toFixed(1);
        } else {
          averageRatings[i] = averageRatings[i].toFixed(1);
        }
      }
    }
  
    return averageRatings;
  };
  const averageRatings = calculateAverageRatingsByDayOfWeek();
  const daysOfWeek = [t('weekInitials.sunday'), t('weekInitials.monday'), t('weekInitials.tuesday'), t('weekInitials.wednesday'), t('weekInitials.thursday'), t('weekInitials.friday'), t('weekInitials.saturday')];

  const chart_3 = {
    tooltip: {
      trigger: 'axis',
    },
    grid: {
      left: 0,
      right: 5,
      top: 8,
      bottom: 5,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: daysOfWeek,
      axisLine: { show: true },
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 0,
        formatter: (value) => value
      },
    },
    yAxis: {
      type: 'value',
      axisLine: { show: true },
      axisLabel: { show: true },
      axisTick: { show: false },
      splitLine: { show: false },
      max: (value) => Math.ceil(value.max / 5) * 5,
      interval: (value) => Math.ceil(value.max / 5) 
    },
    series: [{
      data: averageRatings,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      lineStyle: {
        color: '#273C5A'  // Nuevo color de línea
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, 
            color: 'rgba(239, 201, 76, 0.5)'  // Nuevo color con 50% de opacidad
          }, {
            offset: 1, 
            color: 'rgba(239, 201, 76, 0.05)'  // Nuevo color con 5% de opacidad
          }]
        }
      }
    }]
  };

  // RESEÑAS POR VALORACION
const chart_4 = {
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    left: 0,
    right: 0,
    top: 6,
    bottom: 0,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: ['1 '+t('star'), '2 '+t('stars'), '3 '+t('stars'), '4 '+t('stars'), '5 '+t('stars')],
    axisTick: {
      alignWithLabel: true
    },
    axisLabel: {
      rotate: isMobile ? 50 : 0
    }
  },
  yAxis: {
    type: 'value',
    minInterval: 1,
  },
  series: [{
    name: t('scoredBy'),
    type: 'bar',
    symbol: 'circle', 
    barWidth: '60%',
    data: ratingsDistribution,
    itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,
          [
            {offset: 0, color: 'rgb(239, 201, 76)'},
            {offset: 0.5, color: 'rgb(255, 221, 102)'},
            {offset: 1, color: 'rgb(255, 238, 153)'}
          ]
        )
    },
    emphasis: {
      itemStyle: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [
              {offset: 0, color: 'rgba(255, 238, 153)'},
            {offset: 0.5, color: 'rgba(255, 221, 102)'},
            {offset: 1, color: 'rgba(239, 201, 76)'}
            ]
          )
      }
    }
  }]
};

  // SENTIMIENTO DE RESEÑAS
  if(businessData && Array.isArray(businessData.allReviews) && businessData.allReviews.length > 0){
    businessData.allReviews.forEach(review => {
      if (review.rating >= 4) {
        sentimentData.positivas++;
      } else if (review.rating >= 2) {
        sentimentData.neutrales++;
      } else {
        sentimentData.negativas++;
      }
    });
  }

  const chart_5 = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} ({d}%)'
    },
    legend: {
      orient: isMobile ? 'horizontal' : 'vertical',
      left: 10,
      data: [t('positive'), t('neutral'), t('negative')]
    },
    series: [
      {
        name: t('reviewsFeelingGraph'),
        type: 'pie',
        symbol: 'circle',
        radius: '50%',
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '18',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: sentimentData.positivas, name: t('positive'), id: "positivas",  itemStyle: { color: '#6BA368' } },
          { value: sentimentData.neutrales, name: t('neutral'), id: "neutrales",  itemStyle: { color: '#EFC94C' } },
          { value: sentimentData.negativas, name: t('negative'), id: "negativas" , itemStyle: { color: '#D6453D' }},
        ],
      }
    ]
  };

  const handleChartClick = (params, chartType) => {
    if (params.componentType === 'series') {
      let reviews = [];
      if (chartType === 'timeChart') {
        const selectedDate = sortedLabels[params.dataIndex];
        setSelectedDate(selectedDate);
        reviews = reviewsByDate[selectedDate] || [];
      } else if (chartType === 'ratingChart') {
        const rating = params.dataIndex + 1;
        setSelectedRating(rating);
        reviews = reviewsByRating[params.dataIndex] || [];
      } else if (chartType === 'hourChart') {
        const hour = params.dataIndex;
        setSelectedHour(hour);
        reviews = reviewsByHourData[hour] || [];
      } else if (chartType === 'weekDayChart') {
        const day = params.dataIndex;
        setSelectedDay(dayOfWeek[day])
        reviews = reviewsByDayOfWeek[day] || [];
      }
  
      if (reviews.length > 0) {
        const reviewsHtml = reviews.map(review => {
          const reviewText = review.review ? review.review : t('no_comment');
          return `
                <div class="review-bubble">
                  <p class="review-content">
                    <span class="review-author"><strong>${review.author}</strong> (${review.rating} ${review.rating === 1 ? t('star_down') : t('stars_down')}):</span>
                    <span class="review-text">${reviewText}</span>
                    <span class="review-date"><small>${formatDate(review.date)}</small></span>
                  </p>
                </div>
          `;
        }).join('');
  
        setModalContent(reviewsHtml);
        setModalVisible(true);
      } else {
        console.log("No hay reseñas para mostrar");
      }
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedDate(null);
    setSelectedRating(null);
    setSelectedHour(null);
  };

  const onChart1Events = {
    'click': (params) => {
      handleChartClick(params, 'timeChart');
    }
  };
  
  const onChart2Events = {
    'click': (params) => {
      handleChartClick(params, 'hourChart');
    }
  };

  const onChart3Events = {
    'click': (params) => {
      handleChartClick(params, 'weekDayChart');
    }
  };
  
  const onChart4Events = {
    'click': (params) => {
      handleChartClick(params, 'ratingChart');
    }
  };

  const onChart5Events = {
    'click': (params) => {
      handleSentimentChartClick(params);
    }
  };

  const handleSentimentChartClick = (params) => {
    if (params.data && params.data.id) {
      const sentiment = params.data.id;
      const reviews = reviewsBySentiment[sentiment] || [];
      setsentimentCategory(sentiment);
      if (reviews.length > 0) {
        const reviewsHtml = reviews.map(review => {
          const reviewText = review.review ? review.review : t('no_comment');
          return `
                <div class="review-bubble">
                  <p class="review-content">
                    <span class="review-author"><strong>${review.author}</strong> (${review.rating} ${review.rating === 1 ? t('star_down') : t('stars_down')}):</span>
                    <span class="review-text">${reviewText}</span>
                    <span class="review-date"><small>${formatDate(review.date)}</small></span>
                  </p>
                </div>
          `;
        }).join('');
  
        setModalContent(reviewsHtml);
        setModalVisible(true);
      } else {
        console.log("No hay reseñas para mostrar");
      }
    }
  };
/*
  useEffect(() => {
    if (!loading && businessData) {
      showToast();
    }
  }, [loading, businessData]);
*/
  useEffect(() => {
    if (error) {
      navigate('/404'); // Redirige a la página 404 si hay un error
    }
  }, [error, navigate]);

  if(loading){
    return <LoadingScreen setLoadingComplete={setLoading} />;
  }

  if (user && !user.is_expired && (!businessData || !businessData.allReviews || (Array.isArray(businessData.allReviews) && businessData.allReviews.length===0))) {
    return <NoReviewsCard />;
  }
    
  if (user && !user.is_premium && user.is_expired) {
    return <PremiumRequiredCard />;
  }

  return (
    <div className="content pt-0 myBusiness">
      <div className='footer-margin'>
      {businessData &&
      <>
        {/*<ToastContainer />*/}
        <div className="radius-section">
          <label className="radius-label">{t('myBusinessToast')}</label>
        </div>
        <PrincipalStats data={businessData}/>
        <div className="row">
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header d-flex py-0">
            <div className='card-title'>
              <h6 className="pt-3 mb-0">{t('scoreDistribution')}
                <Tooltip title={t('scoreDistributionTooltip')}>
                  <i className='ph-question ms-2 cursor-pointer'></i>
                </Tooltip>
              </h6>
              <p>{t('scoreDistributionBody')}</p>
            </div>
            </div>

            <div className="card-body">
              <div className="d-sm-flex justify-content-sm-around">
              </div>
          
              <div className="chart-container">
              <ReactECharts
                option={chart_4}
                id="chart_2"
                className="chart"
                style={{height: '200px'}}
                onEvents={onChart4Events}
              />
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-6">
          <div className="card">
            <div className="card-header d-flex py-0">
            <div className='card-title'>
              <h6 className="pt-3 mb-0">{t('reviewsFeeling')}
                <Tooltip title={t('reviewsFeelingTooltip')}>
                  <i className='ph-question ms-2 cursor-pointer'></i>
                </Tooltip>
              </h6>
              <p>{t('reviewsFeelingBody')}</p>
            </div>
            </div>

            <div className="card-body">
              <div className="chart-container">
              <ReactECharts
                option={chart_5}
                id="chart_2"
                className="chart"
                style={{height: '200px'}}
                onEvents={onChart5Events}
              />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex py-0">
                <div className='card-title'>
                  <h6 className="pt-3 mb-0">{t('timeReviews')}
                    <Tooltip title={t('timeReviewsTooltip')}>
                      <i className='ph-question ms-2 cursor-pointer'></i>
                    </Tooltip>
                  </h6>
                  <p>{t('timeReviewsBody')}</p>
                </div>
              </div>
              <div className="chart-container">
                <ReactECharts
                  option={chart_1}
                  id="chart_1"
                  className="chart"
                  style={{ height: '200px' }}
                  onEvents={onChart1Events}
                />
              </div>
            </div>
          </div>
        </div>
      <div className="row">
        <div className="col-lg-6">
          <div className="card">
          <div className="card-header d-flex py-0">
          <div className='card-title'>
              <h6 className="pt-3 mb-0">{t('hourReviews')}
                <Tooltip title={t('hourReviewsTooltip')}>
                  <i className='ph-question ms-2 cursor-pointer'></i>
                </Tooltip>
              </h6>
              <p>{t('hourReviewsBody')}</p>
            </div>
            </div>
          
            <div className="chart-container">
            <ReactECharts
              option={chart_2}
              id="chart_2"
              className="chart"
              style={{height: '200px'}}
              onEvents={onChart2Events}
            />
            </div>
          </div>
        </div>
          
        <div className="col-lg-6">
          <div className="card">
          <div className="card-header d-flex py-0">
            <div className='card-title'>
              <h6 className="pt-3 mb-0">{t('weeklyReviews')}
                <Tooltip title={t('weeklyReviewsTooltip')}>
                  <i className='ph-question ms-2 cursor-pointer'></i>
                </Tooltip>
              </h6>
              <p>{t('weeklyReviewsBody')}</p>
            </div>
            </div>
          
            <div className="chart-container">
            <ReactECharts
                option={chart_3}
                id="chart_2"
                className="chart"
                style={{height: '200px'}}
                onEvents={onChart3Events}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width={800}
        className="custom-modal"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{getModalTitle()}</h5>
            </div>

            <div ref={scrollContainerRef} className="modal-body">
              <div className='modal-reviews-list' dangerouslySetInnerHTML={{ __html: modalContent }} />
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" onClick={handleCloseModal}>OK</button>
            </div>
          </div>
        </div>
      </Modal>
      </>
      
      }
      {/* Modal que se muestra cuando el usuario alcanza el límite */}
      <Modal
        title={t('limitPremiumReached')}
        visible={showLimitModal}
        onCancel={() => handleCloseLimitModal()}
        footer={[
          <Link key="plans" to="/plans" className='btn-upgrade'>
              {t('plans')}
              <i className="ph-arrow-circle-right ms-2"></i>
          </Link>
        ]}
      >
        <p>{t('limitPremiumMessage')}</p>
      </Modal>
      </div>
    </div>
  );
};

export default MyBusiness;
